/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import {
  API,
  fileUpload,
  get,
  imageDefaultPrefixPath,
  ProjectStatus,
} from "../../../config";
import { Modal } from "react-bootstrap";
import { getImportLogDetail } from "./ImportLogsHelper";
import {
  useAllBankList,
  useBankList,
  useStateList,
} from "../../Builders/Projects/components/ProjectsHelper";
import { useUserList } from "../../Builders/BuilderOffices/components/BuilderOfficeHelper";
import { useOfficeList } from "../../Builders/BuilderUsers/components/BuilderUserHelper";
import {
  formatedPostalCode,
  formatName,
  formatOfficeName,
} from "../../common/Misc";
import { Formik } from "formik";
import Spin from "../../common/Spin";
import { AddProjectSchema } from "../../common/Validation";
import Form from "../../Builders/Projects/components/Form";

const NotImportedLogEdit = ({
  logId,
  toggleEditModal,
  fetchNotImportedLogs,
  editModal,
  builderId,
}) => {
  const [loading, setLoading] = useState(false);
  const [projectData, setProjectData] = useState();

  const [selectedOffices, setSelectedOffices] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);

  const formValues = useRef();
  let existingValues = [];
  let overwrittenFields = [];

  const handleFormSubmit = async (value) => {
    const formData = new FormData();

    value.logo = value?.image ? value?.image : value?.logo ? value?.logo : "";

    value.phone = value?.phone ? `${value?.phone}`.replace(/ /g, "") : "";
    value.mobile = value?.mobile ? `${value?.mobile}`.replace(/ /g, "") : "";
    value.abn = value?.abn ? `${value?.abn}`.replace(/ /g, "") : "";

    value.project_opening_balance = Number(
      `${value?.project_opening_balance}`.replace(/,/g, "")
    );
    value.retention_opening_balance = Number(
      `${value?.retention_opening_balance}`.replace(/,/g, "")
    );
    value.estimated_cost = Number(`${value?.estimated_cost}`.replace(/,/g, ""));

    value.logo =
      value?.logo && typeof value?.logo === "string"
        ? value?.logo - imageDefaultPrefixPath
        : value?.logo;

    formData.append("builder_id", builderId ? builderId : "");

    formData.append(
      "project_name",
      value?.project_name ? value?.project_name : ""
    );
    formData.append("email", value?.email ? value?.email : "");
    formData.append("phone", value?.phone ? value?.phone : "");
    formData.append("mobile", value?.mobile ? value?.mobile : "");
    formData.append("abn", value?.abn ? value?.abn : "");

    formData.append("street", value?.street ? value?.street : "");
    formData.append("state_id", value?.state_id ? value?.state_id?.value : "");
    formData.append("suburb_id", value?.suburb_id ? value?.suburb_id?.id : "");
    formData.append(
      "postal_code",
      value?.postal_code ? value?.postal_code : ""
    );
    value?.logo && formData.append("logo", value?.logo ? value?.logo : "");

    if (selectedOffices) {
      if (selectedOffices.length > 0) {
        for (let i = 0; i < selectedOffices.length; i++) {
          formData.append(`office_ids[${i}]`, selectedOffices[i]);
        }
      }
    }

    if (selectedUsers) {
      if (selectedUsers.length > 0) {
        for (let i = 0; i < selectedUsers.length; i++) {
          formData.append(`user_ids[${i}]`, selectedUsers[i]);
        }
      }
    }

    formData.append(
      "project_account_name",
      value?.project_account_name ? value?.project_account_name : ""
    );
    formData.append(
      "project_bsb",
      value?.project_bsb ? value?.project_bsb : ""
    );
    formData.append(
      "project_account_number",
      value?.project_account_number ? value?.project_account_number : ""
    );
    formData.append(
      "project_bank_id",
      value?.project_bank_id ? value?.project_bank_id?.value : ""
    );
    formData.append(
      "project_apca_id",
      value?.project_apca_id ? value?.project_apca_id : ""
    );
    formData.append(
      "project_opening_balance",
      value?.project_opening_balance ? value?.project_opening_balance : 0
    );

    value?.rta_project &&
      formData.append("rta_project_id", value?.rta_project?.id);

    if (!value?.rta_project) {
      formData.append(
        "retention_account_name",
        value?.retention_account_name ? value?.retention_account_name : ""
      );
      formData.append(
        "retention_bsb",
        value?.retention_bsb ? value?.retention_bsb : ""
      );
      formData.append(
        "retention_account_number",
        value?.retention_account_number ? value?.retention_account_number : ""
      );
      formData.append(
        "retention_bank_id",
        value?.retention_bank_id ? value?.retention_bank_id?.value : ""
      );
      formData.append(
        "retention_apca_id",
        value?.retention_apca_id ? value?.retention_apca_id : ""
      );
    }

    formData.append(
      "retention_transaction_start_date",
      value?.retention_transaction_start_date
        ? value?.retention_transaction_start_date
        : ""
    );
    formData.append(
      "retention_apca_id",
      value?.apca_id ? value?.apca_id : "000000"
    );

    formData.append(
      "retention_opening_balance",
      value?.retention_opening_balance ? value?.retention_opening_balance : 0
    );
    formData.append("start_date", value?.start_date ? value?.start_date : "");
    formData.append("end_date", value?.end_date ? value?.end_date : "");

    formData.append(
      "estimated_cost",
      value?.estimated_cost ? value?.estimated_cost : ""
    );
    formData.append(
      "project_status",
      value?.project_status ? value?.project_status?.value : null
    );

    formData.append("_method", "put");

    try {
      setLoading(true);
      const { data } = await fileUpload(
        `${API.PROJECT_IMPORT_LOGS}/${logId}`,
        formData
      );
      setLoading(false);
      if (data) {
        toast.success(data?.message);
        toggleEditModal();
        fetchNotImportedLogs();
        setSelectedOffices([]);
        setSelectedUsers([]);
        // navigate("/clients");
      }
      return data?.data;
    } catch (error) {
      // setProjectData(value);
      setLoading(false);
      setSelectedOffices([]);
      setSelectedUsers([]);
      if (error?.response?.data?.errors) {
        Object.keys(error?.response?.data?.errors).forEach((key) => {
          toast.error(error?.response?.data?.errors[key][0]);
        });
        setLoading(false);
      } else {
        toast.error(error?.message);
        setLoading(false);
      }
    }
  };

  function padWithLeadingZeros(num, totalLength) {
    return String(num).padStart(totalLength, "0");
  }

  // State
  const { stateLoading, stateList = [] } = useStateList();
  const stateListing = stateList?.map((item) => {
    const { id: value, name, short_name, ...rest } = item;
    return { label: name + ` (${short_name})`, value, ...rest };
  });
  const state = stateListing?.find(
    (item) => item?.value === projectData?.state_id
  );

  //Bank
  const { bankLoading, bankList = [] } = useBankList();
  const { allBankLoading, allBankList = [] } = useAllBankList();

  const bankListing = bankList
    ? [...bankList, { label: "Don't have a Retention Trust A/C", value: "" }]
    : [];
  const allBanks = allBankList ? allBankList : [];
  const projectBank = bankListing?.find(
    (item) => item?.value === projectData?.pta_contractor?.bank_id
  );

  const trusteeBank = allBanks?.find(
    (item) => item?.value === projectData?.trustee_contractor?.bank_id
  );

  const retentionBank = bankListing?.find(
    (item) =>
      item?.value ===
      (projectData?.rta_project_id
        ? projectData?.rta_project?.rta_contractor?.bank_id
        : projectData?.rta_contractor?.bank_id)
  );

  //User List
  const { userLoading, userList = [] } = useUserList(builderId);
  const userListing = userList?.map((item) => {
    const name = formatName(item?.first_name, item?.last_name);
    const id = item?.id;
    const items = { name, id, ...item };
    const { name: label, id: value, ...rest } = items;
    return { label, value, ...rest };
  });

  //Office List
  const { officeLoading, officeList = [] } = useOfficeList(builderId);
  const officeListing = officeList?.map((item) => {
    const name = formatOfficeName(item?.street, item?.suburb?.name);
    const id = item?.id;
    const items = { name, id };
    const { name: label, id: value, ...rest } = items;
    return { label, value, ...rest };
  });

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const data = await getImportLogDetail(logId);
        setProjectData(data);
        setSelectedUsers(data?.user_ids);
        setSelectedOffices(data?.office_ids);
        setLoading(false);
      } catch (e) {
        setProjectData(null);
      }
    }
    fetchData();
  }, [logId]);

  return (
    <>
      <Modal
        size="lg"
        show={editModal}
        onHide={toggleEditModal}
        dialogClassName="modal-50w larg-popup review-popup small-review not-import-edit"
        aria-labelledby="contained-modal-title-vcenter"
        className="project-section"
        centered
      >
        <Modal.Header className="mb-0" closeButton>
          Edit Project
        </Modal.Header>
        <Modal.Body style={{ padding: "15px 15px 15px 15px" }}>
          <div
            className="project-add-modal"
            style={{ height: "90vh", overflow: "auto" }}
          >
            <Formik
              initialValues={{
                project_name: projectData?.project_name,
                abn: projectData?.abn,
                mobile: projectData?.mobile,
                phone: projectData?.phone,
                email: projectData?.email,
                street: projectData?.street,
                postal_code: formatedPostalCode(projectData?.postal_code),
                state_id: state,
                suburb_id: projectData?.suburb,
                logo: projectData?.logo
                  ? imageDefaultPrefixPath + projectData?.logo
                  : "",
                user_ids: selectedUsers,
                office_ids: selectedOffices,
                trustee_account_name: projectData?.trustee_contractor
                  ?.account_name
                  ? projectData?.trustee_contractor?.account_name
                  : "",
                trustee_bsb: projectData?.trustee_contractor?.bsb
                  ? projectData?.trustee_contractor?.bsb
                  : "",
                trustee_account_number: projectData?.trustee_contractor
                  ?.account_number
                  ? projectData?.trustee_contractor?.account_number
                  : "",
                trustee_bank_id: trusteeBank ? trusteeBank : "",
                trustee_opening_balance: projectData?.trustee_contractor
                  ?.opening_balance
                  ? projectData?.trustee_contractor?.opening_balance
                  : 0,

                project_account_name: projectData?.pta_contractor?.account_name
                  ? projectData?.pta_contractor?.account_name
                  : "",
                project_bsb: projectData?.pta_contractor?.bsb
                  ? projectData?.pta_contractor?.bsb
                  : "",
                project_account_number: projectData?.pta_contractor
                  ?.account_number
                  ? projectData?.pta_contractor?.account_number
                  : "",
                project_bank_id: projectBank ? projectBank : "",
                project_apca_id: projectData?.pta_contractor?.apca_id
                  ? padWithLeadingZeros(projectData?.pta_contractor?.apca_id, 6)
                  : "",
                project_opening_balance: projectData?.pta_contractor
                  ?.opening_balance
                  ? projectData?.pta_contractor?.opening_balance
                  : 0,

                retention_account_name: projectData?.rta_project_id
                  ? projectData?.rta_project?.rta_contractor?.account_name
                    ? projectData?.rta_project?.rta_contractor?.account_name
                    : "Retention Trust Account"
                  : projectData?.rta_contractor?.account_name
                  ? projectData?.rta_contractor?.account_name
                  : "Retention Trust Account",
                retention_bsb: projectData?.rta_project_id
                  ? projectData?.rta_project?.rta_contractor?.bsb
                    ? projectData?.rta_project?.rta_contractor?.bsb
                    : "000000"
                  : projectData?.rta_contractor?.bsb
                  ? projectData?.rta_contractor?.bsb
                  : "000000",
                retention_account_number: projectData?.rta_project_id
                  ? projectData?.rta_project?.rta_contractor?.account_number
                    ? projectData?.rta_project?.rta_contractor?.account_number
                    : "000000001"
                  : projectData?.rta_contractor?.account_number
                  ? projectData?.rta_contractor?.account_number
                  : "000000001",
                retention_bank_id: retentionBank
                  ? retentionBank
                  : bankListing?.find((i) => i.value === ""),
                retention_apca_id: projectData?.rta_contractor?.apca_id
                  ? padWithLeadingZeros(projectData?.rta_contractor?.apca_id, 6)
                  : "000000",

                retention_opening_balance: projectData?.rta_project_id
                  ? projectData?.rta_project?.rta_contractor?.opening_balance
                    ? projectData?.rta_project?.rta_contractor?.opening_balance
                    : 0
                  : projectData?.rta_contractor?.opening_balance
                  ? projectData?.rta_contractor?.opening_balance
                  : 0,

                retention_transaction_start_date: projectData?.rta_contractor
                  ?.transaction_start_date
                  ? projectData?.rta_contractor?.transaction_start_date
                  : "",
                // start_date: projectData?.start_date
                //   ? new Date(moment(projectData?.start_date, "DD-MM-YYYY"))
                //   : "",
                // end_date: projectData?.end_date
                //   ? new Date(moment(projectData?.end_date, "DD-MM-YYYY"))
                //   : "",
                start_date: projectData?.start_date
                  ? projectData?.start_date
                  : "",
                end_date: projectData?.end_date ? projectData?.end_date : "",
                estimated_cost: projectData?.estimated_cost
                  ? projectData?.estimated_cost
                  : 0,

                rta_project: projectData?.rta_project
                  ? projectData?.rta_project
                  : null,
                project_status:
                  projectData?.project_status !== null
                    ? ProjectStatus?.find(
                        (item) =>
                          item?.value === Number(projectData?.project_status)
                      )
                    : null,
                builder: projectData?.builder_id
                  ? projectData?.builder_id
                  : null,
              }}
              enableReinitialize
              innerRef={formValues}
              onSubmit={handleFormSubmit}
              validateOnBlur={true}
              validateOnChange={true}
              validationSchema={AddProjectSchema}
            >
              {({
                values,
                setErrors,
                errors,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
              }) => {
                return (
                  <>
                    {loading && <Spin />}
                    <Form
                      values={values}
                      errors={errors}
                      setErrors={setErrors}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      handleSubmit={handleSubmit}
                      setFieldValue={setFieldValue}
                      formValues={formValues}
                      overwrittenFields={overwrittenFields}
                      existingValues={existingValues}
                      toggleProjectModal={toggleEditModal}
                      stateListing={stateListing}
                      stateLoading={stateLoading}
                      bankListing={bankListing}
                      bankLoading={bankLoading}
                      builderId={builderId}
                      totalProject={1}
                      projectId={""}
                      setLoading={setLoading}
                      allBankLoading={allBankLoading}
                      allBanks={allBanks}
                      officeListing={officeListing}
                      officeLoading={officeLoading}
                      selectedOffices={selectedOffices}
                      setSelectedOffices={setSelectedOffices}
                      userListing={userListing}
                      userLoading={userLoading}
                      setSelectedUsers={setSelectedUsers}
                      selectedUsers={selectedUsers}
                    />
                  </>
                );
              }}
            </Formik>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default NotImportedLogEdit;
